import PaymentServices from "@/services/payment";
import { forEach } from "lodash";

const FUND = "FUND";

export default {
    data() {
        return {
            fundList: []
        };
    },
    computed: {
        isPaymentFund() {
            // to use this function
            // must have these params :
            // data.paymentTypes && data.payment_type
            let types = this.data.paymentTypes;
            let type = this.data.payment_type;

            return (
                type !== -1 &&
                _.findIndex(types, { id: type, category_id: 2 }) !== -1
            );
        },
        isChangeFund() {
            let change = this.data.change;
            return change && change.type && change.type === FUND;
        }
    },
    methods: {
        getFundList() {
            this.fundList = [];

            PaymentServices.getFundList()
                .then(response => {
                    if (response && response.message.code === 200) {
                        this.fundList = this.processList(
                            response.message.resources
                        );
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },
        processList(array) {
            let newList = array;

            forEach(newList, function (item) {
                item.type = FUND;
                // item.balance = 100;
            });

            return newList;
        },
        getFundName(name, balance) {
            return name + " (" + this._toCurrency(balance) + ")";
        },
        getNameForChange(name, change) {
            return this._toCurrency(change) + " (" + name + ")";
        },
        getFundValue(fundId) {
            let self = this;
            if (fundId) {
                return _.find(self.fundList, function (fund) {
                    return fund.id == fundId;
                });
            }

            return null;
        }
    }
};
